// RuleSet presets — one-click whole-ruleset selection. Applying a preset replaces the working
// RuleSet via store.setRuleSet (which bumps revision so every panel re-evaluates), then the owner may
// keep tuning and Save. Each preset is BUILT fresh (no shared mutable object) so applies are isolated.
// The bundled "俺ルール高得点モード" is the owner's high-scoring house ruleset (DECISIONS.md §4.8 / §7).
import { type RuleSet } from '@mj/protocol';
import { studioDefaultRuleSet } from './defaults';

export interface RuleSetPreset {
  id: string;
  name: { ja: string; en: string };
  description: { ja: string; en: string };
  build: () => RuleSet;
}

export const RULESET_PRESETS: RuleSetPreset[] = [
  {
    id: 'standard',
    name: { ja: '標準ルール', en: 'Standard' },
    description: { ja: '一般的な4人戦の標準設定（capped・裏/槓ドラあり）', en: 'Conventional 4-player defaults' },
    build: () => studioDefaultRuleSet(4),
  },
  {
    id: 'ore-rule-highscore',
    name: { ja: '俺ルール高得点モード', en: "Owner's High-Score Mode" },
    description: {
      ja: '段階青天井・裏/槓ドラ・赤ドラ増・オープン立直+1翻・連風牌4符・和了連荘・ダブル/トリプル役満。とにかく高い点が出る',
      en: 'Stepped aotenjou, ura/kan dora, extra red fives, open-riichi yaku, double-wind 4fu, agari renchan, double/triple yakuman — big numbers',
    },
    build: () => {
      const rs = studioDefaultRuleSet(4); // seededEnabledYaku enables the full catalog incl. open-riichi
      return {
        ...rs,
        tiles: { ...rs.tiles, akaCount: { m: 1, p: 2, s: 1 } },
        scoring: {
          ...rs.scoring,
          limitMode: 'stepped',
          uraDora: true,
          kanDora: true,
          hanRequirement: 1,
          doubleWindPairFu: 4,
          doubleYakuman: true,
          tripleYakuman: true,
        },
        flags: { ...rs.flags, openRiichi: true, renchan: 'agari', nagashiMangan: true, tobi: true },
      };
    },
  },
];

RULESET_PRESETS.push({
  id: 'mugen-pai',
  name: { ja: '無限牌麻雀', en: 'Infinite-Tile Mahjong' },
  description: {
    ja: '全牌が無限供給（復元抽出）・流局なし（和了のみ終了）・累積式（段階青天井）。同一牌の複数槓が解禁され、白の四暗槓＝天地創世まで届く。',
    en: 'Tiles are infinite (draw with replacement); no exhaustive draw; cumulative scoring (stepped). Same-tile multi-kan is possible — up to white four-ankan (天地創世).',
  },
  build: () => {
    const rs = studioDefaultRuleSet(4);
    return {
      ...rs,
      tiles: { ...rs.tiles, infinite: true },
      scoring: { ...rs.scoring, limitMode: 'stepped', doubleYakuman: true, tripleYakuman: true, uraDora: true, kanDora: true },
      flags: { ...rs.flags, nagashiMangan: false, renchan: 'agari', tobi: false },
    };
  },
});

export function buildPreset(id: string): RuleSet | null {
  return RULESET_PRESETS.find((p) => p.id === id)?.build() ?? null;
}
